import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../_metronic/_partials/controls";
import CoreCustomTable from "./component/CoreCustomTable";
import MfaBadge from "./component/MfaBadge";
import { ClearFiltersButton, FilterSelect, MFA_FILTER_OPTIONS, PageSizeSelect, SearchField } from "./component/TableFilters";
import {
  sortCaret,
  headerSortingClasses
} from "../../_metronic/_helpers";
import { useSubheader } from "../../_metronic/layout";
import { Link, useHistory } from "react-router-dom";
import { baseURL } from "../service/API.js";
import moment from "moment";
import Swal from "sweetalert2";
import axios from "axios";
import Pagination2 from "@material-ui/lab/Pagination";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { roleCheck } from '../service/role';
import { hasAction, canAssignUserRole } from '../service/permissions';
import { resetStaffMfa } from '../modules/Auth/_redux/authCrud';
import { apiMessage } from '../service/apiError';

export const User = () => {
  const intl = useIntl();
  const suhbeader = useSubheader();
  const [userData, setUserData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [listError, setListError] = useState('');
  const [search, setSearch] = useState('');
  const [mfaFilter, setMfaFilter] = useState('');
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [_totalSize, setTotalSize] = useState(100);
  suhbeader.setTitle(intl.formatMessage({ id: "109001", defaultMessage: "User Management" }));
  const { authToken, user } = useSelector((state) => state.auth);
  const [campaigns_id_headder, setCampaigns_id_headder] = useState();
  const [roleList, setRoleList] = useState([]);
  const [canViewPii, setCanViewPii] = useState(false);
  const [canAssignRole, setCanAssignRole] = useState(false);

  const history = useHistory();
  useEffect(() => {
    localStorage.removeItem('edit')
    checkAuth()

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkAuth =async()=> {
    
    const [data, pii, roleTypes] = await Promise.all([roleCheck('USER'), roleCheck('USER_PII'), roleCheck('ROLE')])
    setCanAssignRole(canAssignUserRole(data, roleTypes))
    setCanViewPii(pii.includes('VIEW'))
    setRoleList(data)
    if (!hasAction(data, 'VIEW')) {
      history.push('/auth/login')
      return
    }
    let campaigns_id_headders = localStorage.getItem("campaigns_id_headder")
    setCampaigns_id_headder(campaigns_id_headders);

    let value = 1
    if (localStorage.getItem("userPage") != null) {
      value = localStorage.getItem("userPage")
    }
    getUser(value, 10, search, campaigns_id_headders);
  }

  const getUser = async (page, limit, searchTerm, campaigns_id_headders, mfa = mfaFilter) => {
    setPage(page);
    setIsLoading(true);
    setListError('');
    const query = [
      `page=${page}`,
      `limit=${limit}`,
      searchTerm ? `search=${encodeURIComponent(searchTerm)}` : '',
      mfa !== '' && mfa !== undefined ? `mfa=${mfa}` : '',
    ].filter(Boolean).join('&');
    axios({
      method: "get",
      url: `${baseURL}/api/v1/user/list?${query}`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    }).then((res) => {
      if (res.message) {
        history.push("/logout");
        return;
      }
      // Rebuilt from the response every time. This used to push into an array
      // held in the component body, which survives a re-render — so a second
      // fetch appended to the first and the table grew instead of refreshing.
      setUserData(res.data.data.map((data) => ({
        id: data.id,
        firstname: data.firstname,
        lastname: data.lastname,
        email: data.email,
        role_id: data.role_id,
        mfa_enabled: Boolean(data.mfa_enabled),
        created_at: moment(data.created_at).format("YYYY-MM-DD HH:mm:ss"),
        updated_at: moment(data.updated_at).format("YYYY-MM-DD HH:mm:ss"),
      })));

      var totalpage = Math.ceil(res.data.total / res.data.limit);
      setTotalPage(totalpage);
      setTotalSize(res.data.total);
      setLimit(res.data.limit);
    })
      // There was no rejection handler at all: a failed list left the previous
      // rows on screen and said nothing.
      .catch((err) => {
        setUserData([]);
        setListError(apiMessage(err, 'โหลดรายชื่อผู้ใช้ไม่สำเร็จ'));
      })
      .finally(() => setIsLoading(false));
  };

  const _checkNull = (data) => {
    if (data) {
      return data
    }
    return intl.locale === 'th' ? 'ไม่มีข้อมูล' : 'No Data'
  }

  const columns = [
    // {
    //   dataField: "id",
    //   text: intl.formatMessage({ id: "109030" ,defaultMessage:"ID"}),
    //   sort: true,
    //   sortCaret: sortCaret,
    //   headerSortingClasses,
    // },
    {
      dataField: "firstname",
      text: intl.formatMessage({ id: "109031", defaultMessage: "Firstname" }),
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "lastname",
      text: intl.formatMessage({ id: "109031", defaultMessage: "Lastname" }),
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "email",
      text: intl.formatMessage({ id: "109032", defaultMessage: "USERNAME" }),
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "created_at",
      text: intl.formatMessage({ id: "109033", defaultMessage: "Create At" }),
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "updated_at",
      text: intl.formatMessage({ id: "109033", defaultMessage: "Update At" }),
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "mfa_enabled",
      text: "MFA",
      formatter: (enabled) => <MfaBadge enabled={enabled} />,
    },
    {
      text: intl.formatMessage({ id: "109034", defaultMessage: "default content" }),
      dataField: "id",
      formatter: (id, row, rowIndex) => {
        return (
          <div>
            {hasAction(roleList, 'EDIT') && <button
              type="button"
              className="btn btn-primary mr-2"
              onClick={() => editItem({ id, row, rowIndex })}
            >
              {intl.formatMessage({ id: "109004", defaultMessage: "edit" })}
            </button>}

            {hasAction(roleList, 'DELETE') && <button
              type="button"
              className="btn btn-primary"
              onClick={() => deleteItem({ row, rowIndex })}
            >
              {intl.formatMessage({ id: "109005", defaultMessage: "delete" })}
            </button>}
            {(hasAction(roleList, 'EDIT') || hasAction(roleList, 'DELETE')) && <button
              type="button"
              className="btn btn-warning ml-2"
              onClick={() => resetMfa({ row })}
            >
              Reset MFA
            </button>}
          </div>
        );
      },
    },
  ];
  const editItem = (data) => {
    history.push(`/EditUser?id=${encodeURIComponent(data.id)}`);
  };

  const resetMfa = (data) => {
    Swal.fire({
      title: 'รีเซ็ตการยืนยัน 2 ขั้นตอน?',
      text: 'อุปกรณ์ที่ผูกไว้จะใช้ไม่ได้ทันที และผู้ใช้ต้องสแกน QR ผูกแอปใหม่ตอนเข้าสู่ระบบครั้งถัดไป',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'รีเซ็ต',
      cancelButtonText: 'ยกเลิก',
    }).then((result) => {
      if (!result.value) return
      resetStaffMfa(data.row.id)
        .then(() => {
          const selfId = user && user.data && user.data.id
          const resetSelf = Number(data.row.id) === Number(selfId)
          return Swal.fire({ title: 'รีเซ็ตการยืนยัน 2 ขั้นตอนเรียบร้อย', icon: 'success', confirmButtonText: 'ตกลง' }).then(() => {
            if (resetSelf) {
              window.location.assign('/logout')
              return
            }
            getUser(page, limit, search, campaigns_id_headder)
          })
        })
        .catch((err) => {
          Swal.fire({
            title: 'รีเซ็ตไม่สำเร็จ',
            text: apiMessage(err, 'รีเซ็ต MFA ไม่สำเร็จ กรุณาลองใหม่'),
            icon: 'error',
            confirmButtonText: 'ok',
          })
        })
    })
  }

  const deleteItem = (data) => {
    let token = localStorage.getItem("Token");
    Swal.fire({
      title: intl.formatMessage({ id: "113107", defaultMessage: "Are you sure?" }),
      text: intl.formatMessage({ id: "113108", defaultMessage: "You will not be able to recover this template !" }),
      icon: "question",
      showCancelButton: true,
      confirmButtonText: intl.formatMessage({ id: "113109", defaultMessage: "Yes, delete it!" }),
      cancelButtonText: intl.formatMessage({ id: "113110", defaultMessage: "No, keep it" }),
    }).then((result) => {
      if (result.value) {
        // There is no DELETE /user/:id — it answered 404 "Not found", so this
        // button never worked. Removal is a soft delete: PUT /user/remove/:id
        // with the flag to set.
        axios
          .put(`${baseURL}/api/v1/user/remove/${data.row.id}`,
            { status: true },
            {
              headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
              },
            })
          .then((res) => {
            // The endpoint answers 200 even when it refuses, with success:false
            // and the reason in the body — so a failed delete used to report
            // "Deleted!" and the row stayed put.
            const body = res && res.data
            if (body && body.success === false) {
              Swal.fire({
                title: intl.formatMessage({ id: "113113", defaultMessage: "Your template has been fail to deleted." }),
                text: apiMessage({ response: { status: 400, data: body } }, 'ลบผู้ใช้ไม่สำเร็จ กรุณาลองใหม่'),
                icon: "error",
                confirmButtonText: intl.formatMessage({ id: "113116", defaultMessage: "ok" }),
              })
              return
            }
            Swal.fire({
              title: intl.formatMessage({ id: "113111", defaultMessage: "Deleted!" }),
              text: intl.formatMessage({ id: "113112", defaultMessage: "Your template has been deleted." }),
              icon: "success",
              confirmButtonText: intl.formatMessage({ id: "113116", defaultMessage: "ok" }),

            }
            );
            getUser(1, limit, search, campaigns_id_headder);
          })
          .catch((err) => {
            Swal.fire({
              title: intl.formatMessage({ id: "113113", defaultMessage: "Your template has been fail to deleted." }),
              text: apiMessage(err, 'ลบผู้ใช้ไม่สำเร็จ กรุณาลองใหม่'),
              icon: "error",
              confirmButtonText: intl.formatMessage({ id: "113116", defaultMessage: "ok" }),

            }
            );
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          title: intl.formatMessage({ id: "113114", defaultMessage: "Cancelled" }),
          text: intl.formatMessage({ id: "113115", defaultMessage: "Your template is safe :)" }),
          icon: "error",
          confirmButtonText: intl.formatMessage({ id: "113116", defaultMessage: "ok" }),
        }
        );
      }
    });
  };
  const handleSearch = () => {
    if (!canViewPii && search) return;
    setPage(1);
    getUser(1, limit, search, campaigns_id_headder);
  };

  // Clearing has to re-fetch, not just empty the fields. Leaving the previous
  // results under an empty toolbar is the state operators read as "no more matches".
  const handleClearFilters = () => {
    setSearch("");
    setMfaFilter("");
    setPage(1);
    getUser(1, limit, "", campaigns_id_headder, "");
  };

  const handlePageChange = (event, value) => {
    setPage(value);

    localStorage.setItem("userPage", value)

    getUser(value, limit, search, campaigns_id_headder);
  };

  const handlePageSizeChange = (event) => {
    setPage(1);
    setLimit(event.target.value);
    getUser(1, event.target.value, search, campaigns_id_headder);
  };

  const handleMfaFilterChange = (event) => {
    const next = event.target.value;
    setMfaFilter(next);
    setPage(1);
    localStorage.setItem("userPage", 1)
    getUser(1, limit, search, campaigns_id_headder, next);
  };

  return (
    <Card>
      <CardHeader title={intl.formatMessage({ id: "109001", defaultMessage: "User Management" })}>
        <CardHeaderToolbar>
          <Link to="/CreateUser">
            {canAssignRole && hasAction(roleList, 'CREATE') &&<button type="button" className="btn btn-primary">
              {intl.formatMessage({ id: "107009", defaultMessage: "Create" })}
            </button>}
          </Link>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <div className="row form-inline mb-2">
          <div className="col-lg-4 col-md-4 col-sm-4">
            <div className="form-group">
              {/* The API searches these three columns — the old generic
                  "Text Search" gave no clue, and it never reached the query. */}
              <SearchField
              disabled={!canViewPii}
                placeholder="ค้นหา ชื่อ / นามสกุล / อีเมล"
                value={search}
                onChange={setSearch}
                onSearch={handleSearch}
              />
            </div>
          </div>
          <div className="col-lg-3 col-md-3 col-sm-3">
            <div className="form-group">
              <FilterSelect
                value={mfaFilter}
                onChange={handleMfaFilterChange}
                options={MFA_FILTER_OPTIONS}
              />
            </div>
          </div>
          <div className="col-lg-2 col-md-2 col-sm-2">
            <div className="form-group">
              <button
                type="button"
                id="button"
                className="btn btn-primary"
                style={{ width: "100%" }}
                disabled={isLoading}
                onClick={() => handleSearch()}
              >
                {isLoading
                  ? 'กำลังค้นหา...'
                  : intl.formatMessage({ id: "109003", defaultMessage: "search" })}
              </button>
            </div>
          </div>
          <div className="col-lg-1 col-md-1 col-sm-1">
            <div className="form-group">
              <ClearFiltersButton
                show={Boolean(search || mfaFilter)}
                onClear={handleClearFilters}
              />
            </div>
          </div>
        </div>

        <CoreCustomTable
          data={userData}
          columns={columns}
          loading={isLoading}
          error={listError}
          emptyText="ไม่พบผู้ใช้ที่ตรงกับเงื่อนไข"
        />
        <div className=" col-lg-12">
          <div className="row">
            <div className="col-lg-6">
              <div className="mt-3">
                <PageSizeSelect
                  label={intl.formatMessage({ id: "109035", defaultMessage: "Item per page" })}
                  value={limit}
                  onChange={handlePageSizeChange}
                />
              </div>
            </div>
            <div className="col-lg-6">
              <Pagination2
                className="mt-3 "
                count={totalPage}
                page={localStorage.getItem("userPage") != null ? Number(localStorage.getItem("userPage")) : page}
                siblingCount={1}
                boundaryCount={1}
                variant="outlined"
                shape="rounded"
                onChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
